var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logos-comp",style:({ backgroundImage: `url(${_vm.bgImg})` })},[_c('div',{staticClass:"logos-box"},_vm._l((_vm.logos),function(img,index){return _c('div',{key:index,staticClass:"logo-item"},[_c('img',{attrs:{"src":img}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }